import classNames from 'classnames';
import React, { ElementType, FC, memo, MouseEventHandler } from 'react';
import { NavLink } from 'react-router-dom';

import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './SidebarMenuItem.styles.m.css';

interface ISidebarMenuItemProps {
  title: string;
  link: string;
  Icon: ElementType;
  onClick?: MouseEventHandler<HTMLElement>;
}

export const SidebarMenuItem: FC<ISidebarMenuItemProps> = memo(({ title, link, Icon, onClick }) => {
  return (
    <NavLink
      className={({ isActive }): string =>
        classNames(styles.container, {
          [styles.active]: isActive,
        })
      }
      to={link}
      end
      onClick={onClick}
    >
      <span className={styles.icon}>
        <IconView
          Icon={Icon}
          size={IconViewSizes.Small}
        />
      </span>
      <span className={styles.title}>{title}</span>
    </NavLink>
  );
});
